export const integrationsKeys = {
  activationSummary: (workspaceId: number) =>
    ['workspaces', workspaceId, 'integrations', 'activationSummary'] as const,
} as const
